import { useWizard } from "react-use-wizard";
import { TKeyOfDataWizardBuy, TNumberKeysOfIFillDataWizardBuy } from "../../..";
import buySteps from "../../buySteps";
import ChooseAreaStep from "../../../../../../../shared/wizard/steps/chooseAreaStep";
import useGeoPolygonByBuilding from "../../../../../../../../api/hooks/use-geo-polygon-by-building";
interface ISelectionByOwnSwapStep_4 {
  isNextStepDisabled: boolean;
  onChange: (data: number[], key: TNumberKeysOfIFillDataWizardBuy) => void;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
  data: number[] | null;
  buildingId: number | null;
}

const SelectionByOwnSwapStep_4 = ({
  isNextStepDisabled,
  data,
  onChange,
  onReset,
  buildingId,
}: ISelectionByOwnSwapStep_4) => {
  const { goToStep } = useWizard();

  const { trigger } = useGeoPolygonByBuilding();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_3);
    onReset(["rejectedLocationIds"]);
  };

  const handleNextStep = async () => {
    if (buildingId) {
      const data = await trigger(buildingId);
      onChange([data.id], "rejectedLocationIds");
    }
    goToStep(buySteps.selectionSteps.swap.step_5);
  };

  return (
    <div>
      <ChooseAreaStep
        isNextStepDisabled={isNextStepDisabled}
        handleNextStep={handleNextStep}
        handlePrevStep={handlePrevStep}
        data={data}
        onChange={onChange}
      />
    </div>
  );
};

export default SelectionByOwnSwapStep_4;
